import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const ItemSwap = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 rounded-md flex flex-col gap-3 p-5 duration-150'>

      <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
        {store} 반출 / 반입 / 매입
      </div>

      <div className='flex gap-3 justify-start items-center'>
        <div>
          {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
        </div>
        <div>
          <div>제품 반출</div>
          <div className='flex gap-1'>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data0))} 건`}</p>
            <p>|</p>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data1))} 개`}</p>
          </div>
        </div>        
      </div>

      <div className='flex gap-3 justify-start items-center'>
        <div>
          {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
        </div>
        <div>
          <div>제품 반입</div>
          <div className='flex gap-1'>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data2))} 건`}</p>
            <p>|</p>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data3))} 개`}</p>
          </div>
        </div>        
      </div>

      <div className='flex gap-3 justify-start items-center'>
        <div>
          {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
        </div>
        <div>
          <div>제품 매입</div>
          <div className='flex gap-1'>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data4))} 건`}</p>
            <p>|</p>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data5))} 개`}</p>
          </div>
        </div>        
      </div>

      <div className='flex gap-3 justify-start items-center'>
        <div>
          {/* <p className='p-1 w-8 h-8 bg-blue-500 rounded-3xl'></p> */}
        </div>
        <div>
          <div>제품 취소</div>
          <div className='flex gap-1'>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data6))} 건`}</p>
            <p>|</p>
            <p className='whitespace-nowrap tracking-wider'>{`${NumberConvert(Number(data.data7))} 개`}</p>
          </div>
        </div>        
      </div>
      
    </div>
  )
}

export default ItemSwap